import { classNames } from "helpers";
import React from "react";
import { CheckBoxProps } from "./types";


const CheckBox: React.FC<CheckBoxProps> = ({
  name,
  checked,
  onChange,
  disabled,
  label,
  error,
}) => {



  return (
    <>
      <div>
        <label className={classNames("flex items-center gap-2 text-sm font-medium text-gray-700 cursor-pointer", label ? "" : "")}>
          <input
            name={name}
            checked={checked}
            onChange={(e) => onChange?.(e, e.target.checked)}
            disabled={disabled}
            type="checkbox"
            className="sr-only"
          />
          <div
            className={classNames(
              disabled ? "opacity-60" : "",
              error ? "border-red-500 ring-1 ring-red-500" : "",
              checked
                ? "bg-amber-500 border-amber-500"
                : "border-gray-300 bg-white",
              "w-4 h-4 rounded-sm border flex items-center justify-center shrink-0"
            )}
          >
            {checked && (
              <svg
                className="w-3 h-3 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={3}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
          {label && <span>{label}</span>}
        </label>
      </div>
      {error && (
        <div>
          <p className="mt-1 text-sm text-red-600">
            {error}
          </p>
        </div>
      )}
    </>
  );
};

export default React.memo(CheckBox);
